import React from 'react';
import { AlertDanger, AlertSuccess, AlertWarning } from '../shared/alert-manager';
import { getAllCamerasLPRByParkId } from "../store/collections/cameraLPRWorker";
import { getAllDevicesByParkId } from "../store/collections/deviceWorker";
import { getAllEquipmentsByParkId } from "../store/collections/equipmentWorker";
import { getLicencaByParkId } from "../store/collections/licencaWorker";
import { getPlanById } from '../store/collections/monthlyPlans';
import { getCountNotesByParkIdAndDates } from '../store/collections/newNotesWorker';
import { getCountTicketsByParkIdAndDates } from '../store/collections/ticketWorker';
import { getAllUsersActiveByClientId } from "../store/collections/userWorker";
import { getCountMessagesByParkIdAndDates } from '../store/collections/whatsappWorker';

export const getMaxQuantityOfUsersByClienteId = async ({ estacionamentoId }) => {
    const licence = await getLicencaByParkId({ estacionamentoId: estacionamentoId })
    const items = await getAllUsersActiveByClientId({ clienteId: licence.clienteId })
    const actives = items.filter(e => e.email.includes("@selfparking.com.br") == false)
    const maximum = licence.plan?.quantidadeUsuariosAtivos ?? 2
    if (actives.length >= maximum) {
        return {
            success: false,
            message: `Esta conta atingiu o limite máximo de usuários ativos que são de ${maximum}, entre em contato com o comercial ou suporte para solicitar novos usuários no seu plano.`
        }
    }
    return {
        success: true,
    }
}

export const getMaxQuantityOfTotensByParkId = async ({ estacionamentoId }) => {
    const licence = await getLicencaByParkId({ estacionamentoId: estacionamentoId })
    const maximum = licence.plan?.quantidadeTotens ?? 1
    if (maximum === 0) {
        return {
            success: false,
            message: `Esta conta não possui licença para utilizar totens, entre em contato com o comercial ou suporte para solicitar esta função no seu plano.`
        }
    }
    const items = await getAllEquipmentsByParkId({ estacionamentoId: estacionamentoId })
    if (items.length >= maximum) {
        return {
            success: false,
            message: `Esta conta atingiu o limite máximo de totens ativos que são de ${maximum}, entre em contato com o comercial ou suporte para solicitar novos totens no seu plano.`
        }
    }
    return {
        success: true,
    }
}

export const getMaxQuantityOfLPRsByParkId = async ({ estacionamentoId }) => {
    const licence = await getLicencaByParkId({ estacionamentoId: estacionamentoId })
    const maximum = licence.plan?.quantidadeLPR ?? 1
    if (maximum === 0) {
        return {
            success: false,
            message: `Esta conta não possui licença para utilizar camera LPR, entre em contato com o comercial ou suporte para solicitar esta função no seu plano.`
        }
    }
    var items = await getAllCamerasLPRByParkId({ estacionamentoId: estacionamentoId })
    if (items.length >= maximum) {
        return {
            success: false,
            message: `Esta conta atingiu o limite máximo de cameras LPR ativas que são de ${maximum}, entre em contato com o comercial ou suporte para solicitar novas licencas no seu plano.`
        }
    }
    return {
        success: true,
    }
}

export const getMaxQuantityOfTotemAutoAtendimentosByParkId = async ({ estacionamentoId }) => {
    const licence = await getLicencaByParkId({ estacionamentoId: estacionamentoId })
    const maximum = licence.plan?.quantidadeAutoAtendimento ?? 1
    if (maximum === 0) {
        return {
            success: false,
            message: `Esta conta não possui licença para utilizar totens de auto atendimento, entre em contato com o comercial ou suporte para solicitar esta função no seu plano.`
        }
    }
    var items = await getAllDevicesByParkId({ estacionamentoId: estacionamentoId })
    const autoAtendimento = items.filter(e => e.useMode === "TOTEM")
    if (autoAtendimento.length >= maximum) {
        return {
            success: false,
            message: `Esta conta atingiu o limite máximo de totens de auto atendimento ativos que são de ${maximum}, entre em contato com o comercial ou suporte para solicitar novos totens de auto atendimento no seu plano.`
        }
    }
    return {
        success: true,
    }
}

export const getAllConsumeByParkIdAndDates = async ({ estacionamentoId, startDate, endDate }) => {
    const licence = await getLicencaByParkId({ estacionamentoId: estacionamentoId })
    /*if (!licence?.plan) {
        return null
    }
    const plan = await getPlanById({ id: licence.plan.id })
    if (!plan) {
        return null
    }*/
    const quantityVehicles = parseInt(licence?.plan?.quantidadeVeiculosMes ?? 1500)
    const quantityNotesMonth = parseInt(licence?.plan?.quantidadeNotasMes ?? 100)
    const quantityMessagesMonth = parseInt(licence?.plan?.quantidadeMensagensMes ?? 20)

    const quantityTickets = await getCountTicketsByParkIdAndDates({ startDate: startDate, endDate: endDate, estacionamentoId: estacionamentoId })
    let percentageTickets = ((quantityTickets / quantityVehicles) * 100)

    const quantityNotes = await getCountNotesByParkIdAndDates({ startDate: startDate, endDate: endDate, estacionamentoId: estacionamentoId })
    let percentageNotes = ((quantityNotes / quantityNotesMonth) * 100)

    const quantityMessages = await getCountMessagesByParkIdAndDates({ startDate: startDate, endDate: endDate, estacionamentoId: estacionamentoId })
    let percentageMessages = ((quantityMessages / quantityMessagesMonth) * 100)

    return {
        tickets: {
            quantity: quantityTickets,
            remaining: quantityVehicles - quantityTickets,
            maximum: quantityVehicles,
            percentage: parseFloat(percentageTickets.toFixed(2)),
            average: percentageTickets < 30 ? "LOW" : percentageTickets < 70 ? "MEDIUM" : percentageTickets <= 100 ? "HIGH" : "CRITICAL",
        },
        notes: {
            quantity: quantityNotes,
            remaining: quantityNotesMonth - quantityNotes,
            maximum: quantityNotesMonth,
            percentage: parseFloat(percentageNotes.toFixed(2)),
            average: percentageNotes < 30 ? "LOW" : percentageNotes < 70 ? "MEDIUM" : percentageNotes <= 100 ? "HIGH" : "CRITICAL",
        },
        messages: {
            quantity: quantityMessages,
            remaining: quantityMessagesMonth - quantityMessages,
            maximum: quantityMessagesMonth,
            percentage: parseFloat(percentageMessages.toFixed(2)),
            average: percentageMessages < 30 ? "LOW" : percentageMessages < 70 ? "MEDIUM" : percentageMessages <= 100 ? "HIGH" : "CRITICAL",
        },
        startDate: startDate,
        endDate: endDate
    }
}

class LicenceNoteLimitWarning extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            estacionamentoId: props.estacionamentoId,
        }
    }

    componentDidMount = async () => {
        const licence = await getLicencaByParkId({ estacionamentoId: this.state.estacionamentoId })
        var quantity = licence.plan?.quantidadeNotasMes ?? 0
        if (quantity === 0) {
            this.setState({
                message: `Este estabelecimento não possui licença para emitir notas fiscais, entre em contato com o comercial ou suporte para solicitar esta funcionalidade paga no seu plano.`,
                type: "success"
            })
        } else {
            this.setState({
                message: `A licença para este estabelecimento tem a permissão para emitir até ${quantity} notas.`,
                type: "warning"
            })
        }
    }

    render() {
        return <>
            {
                this.state.type === "success" &&
                <AlertSuccess message={this.state.message} />
            }
            {
                this.state.type === "warning" &&
                <AlertWarning message={this.state.message} />
            }
            {
                this.state.type === "danger" &&
                <AlertDanger message={this.state.message} />
            }
        </>
    }
}

export { LicenceNoteLimitWarning };
